import Sidebar from './component'

export default Sidebar
